import { render, staticRenderFns } from "./FormInputTextareaWidget.vue?vue&type=template&id=9389fa34&"
import script from "./FormInputTextareaWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputTextareaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports